import { observer } from 'mobx-react-lite'
import { OCRConfirmReviewDialog } from '@/features/jobs/scoping/components/OCRConfirmReviewDialog'
import { type OCRConfirmReviewDialogViewModel } from './OCRConfirmReviewDialogViewModel'

export interface OCRConfirmReviewDialogContainerProps {
  vm: OCRConfirmReviewDialogViewModel
}

export const OCRConfirmReviewDialogContainer = observer(
  function OCRConfirmReviewDialogContainer({
    vm,
  }: OCRConfirmReviewDialogContainerProps) {
    return (
      <OCRConfirmReviewDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onConfirm={vm.review}
      />
    )
  },
)
